import { GeckoEditableFeature } from 'types/assetModel/features/baseClasses/geckoEditableFeature'
import { GeckoComponentRect } from 'types/geometric/geckoComponentRect'
import { GeckoMeasurementUnit } from 'types/measurement/geckoMeasurementUnit'

export class GeckoWeld extends GeckoEditableFeature {
  readonly name: string | undefined
  readonly feature_geometry: GeckoComponentRect

  constructor(
    component_id: string,
    id: string,
    name: string | undefined,
    x_start: number,
    y_start: number,
    x_end: number,
    y_end: number
  ) {
    super(id)
    this.name = name
    this.feature_geometry = GeckoComponentRect.CreateFromXYs(
      component_id,
      x_start,
      y_start,
      x_end,
      y_end,
      GeckoMeasurementUnit.Meters,
      GeckoMeasurementUnit.Meters
    )
  }
}
